import { render, staticRenderFns } from "./defen.vue?vue&type=template&id=55555bd5&scoped=true&"
import script from "./defen.vue?vue&type=script&lang=js&"
export * from "./defen.vue?vue&type=script&lang=js&"
import style0 from "./defen.vue?vue&type=style&index=0&id=55555bd5&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "55555bd5",
  null
  
)

export default component.exports